import { styled } from 'baseui'

import { pollColor } from '@/shared/tools/communicationBoardPolls'

export const ThanksRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.625rem',
})

export const ThanksFace = styled<'span', { $colorKey: string }>('span', ({ $theme, $colorKey }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '2.25rem',
  height: '2.25rem',
  borderRadius: '999px',
  color: $theme.colors.white,
  backgroundColor: pollColor($theme, $colorKey),
}))

export const ThanksText = styled('span', ({ $theme }) => ({
  fontSize: '0.8125rem',
  lineHeight: '1.4',
  fontWeight: 600,
  color: $theme.colors.noticeOkText,
}))
